<template>
  <div>
    <div class="ch-head">
      <div>
        <h1>订单预警</h1>
        <p>已接入保证金欠缴和已复核未打款。窜货、低价、套奖没有订单级规则，数量保持为 0。</p>
      </div>
    </div>
    <div class="ch-metrics three">
      <div class="ch-metric"><div class="k">保证金欠缴</div><div class="v">{{ count('保证金欠缴') }}</div></div>
      <div class="ch-metric"><div class="k">已复核未打款</div><div class="v">{{ count('已复核未打款') }}</div></div>
      <div class="ch-metric"><div class="k">窜货 / 低价 / 套奖</div><div class="v">0</div><div class="s">未接入</div></div>
    </div>
    <div class="ch-panel">
      <table class="ch-table">
        <thead><tr><th>类型</th><th>渠道</th><th>说明</th></tr></thead>
        <tbody>
          <tr v-for="(row, index) in list" :key="index">
            <td>{{ row.type }}</td>
            <td>{{ row.partnerName }}</td>
            <td>{{ row.detail }}</td>
          </tr>
          <tr v-if="!list.length"><td colspan="3" class="ch-empty">暂无预警</td></tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { getChannelAlerts } from '@/api/admin'

export default {
  name: 'HqAlerts',
  data() { return { list: [] } },
  created() { this.load() },
  methods: {
    count(type) { return this.list.filter(item => item.type === type).length },
    async load() {
      const result = await getChannelAlerts()
      this.list = result.list || []
    }
  }
}
</script>
